(() => {
  const DATA_ID = 'LocalizationCountryData';
  const LIST_SELECTOR = '[data-country-options-lazy]';
  let countries;

  function getCountries() {
    if (countries) return countries;

    const data = document.getElementById(DATA_ID);
    if (!data) return [];

    try {
      countries = JSON.parse(data.textContent);
    } catch (error) {
      countries = [];
      console.error('Unable to load Shopify country options.', error);
    }

    return countries;
  }

  function enableCountryInputs(root = document) {
    root.querySelectorAll(`${LIST_SELECTOR} ~ [data-popout-input]`).forEach((input) => {
      input.disabled = false;
    });
  }

  function observeFlags(list) {
    const flags = list.querySelectorAll('[data-country-flag-src]');
    if (!flags.length) return;

    const loadFlag = (flag) => {
      flag.src = flag.dataset.countryFlagSrc;
      flag.removeAttribute('data-country-flag-src');
    };

    if (!('IntersectionObserver' in window)) {
      flags.forEach(loadFlag);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadFlag(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {root: list, rootMargin: '120px 0px'}
    );

    flags.forEach((flag) => observer.observe(flag));
  }

  function createOption(country, currentCode, showFlags) {
    const item = document.createElement('li');
    item.className = 'popout-list__item';

    if (country.code === currentCode) {
      item.classList.add('is-active');
    }

    const option = document.createElement('a');
    option.className = 'popout-list__option';
    option.href = '#';
    option.dataset.value = country.code;
    option.setAttribute('data-popout-option', '');

    if (country.code === currentCode) {
      option.setAttribute('aria-current', 'true');
    }

    if (showFlags && country.flagUrl) {
      const flag = document.createElement('img');
      flag.className = 'popout__flag';
      flag.alt = '';
      flag.width = 40;
      flag.loading = 'lazy';
      flag.dataset.countryFlagSrc = country.flagUrl;
      option.appendChild(flag);
    }

    const label = document.createElement('span');
    label.textContent = `${country.name} (${country.currencyCode} ${country.currencySymbol})`;
    option.appendChild(label);
    item.appendChild(option);

    return item;
  }

  function populateCountryList(list) {
    if (list.dataset.countryOptionsLoaded === 'true') return;

    const popout = list.closest('popout-select');
    const input = popout?.querySelector('[data-popout-input]');
    const currentCode = input?.value || '';
    const showFlags = list.dataset.countryFlags === 'true';
    const fragment = document.createDocumentFragment();

    getCountries().forEach((country) => {
      fragment.appendChild(createOption(country, currentCode, showFlags));
    });

    list.appendChild(fragment);
    list.dataset.countryOptionsLoaded = 'true';

    if (popout) {
      popout.popoutOptions = list.querySelectorAll('[data-popout-option]');
      popout.popoutOptions.forEach((option) => {
        option.addEventListener('click', (event) => popout.popupOptionsClick(event));
      });
    }

    observeFlags(list);
  }

  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest('[data-popout-toggle]');
      const popout = toggle?.closest('popout-select');
      const list = popout?.querySelector(LIST_SELECTOR);

      if (list) populateCountryList(list);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enableCountryInputs());
  } else {
    enableCountryInputs();
  }

  document.addEventListener('shopify:section:load', (event) => enableCountryInputs(event.target));
})();
